<template>
  <div>
    <h3 class="setting-item">训练时间:
    </h3>
    <vue-numeric-input v-model="newVal"
                       :min="1"
                       :max="10"
                       :step="1" />
    分
  </div>
</template>

<script>
export default {
  props: {
    duration: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      newVal: this.duration,
    }
  },
  watch: {
    newVal: function(val) {
      this.$emit('update:duration', val)
    },
  },
}
</script>

